/**
 * @generated SignedSource<<1d78641a3a540fe4bce5155e202c97d4>>
 * @relayHash ef68fc30c606e6d65d5db736e278ad8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9cfd27e96cde0fd15266ddb2222eed4ee194d3a64fe28737274c99b2e21fe6db

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalUpdatesAsideViewAggQuery$variables = {
  completedGoalsSearchString: string;
  containerId: string;
  newGoalsSearchString: string;
  ownGoalsSearchString: string;
};
export type GoalUpdatesAsideViewAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalUpdatesSideColumnAgg">;
};
export type GoalUpdatesAsideViewAggQuery = {
  response: GoalUpdatesAsideViewAggQuery$data;
  variables: GoalUpdatesAsideViewAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completedGoalsSearchString"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newGoalsSearchString"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownGoalsSearchString"
},
v4 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "concreteType": "TownsquareGoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v10 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v11 = {
  "kind": "Literal",
  "name": "sort",
  "value": [
    "CREATION_DATE_DESC"
  ]
},
v12 = [
  {
    "concreteType": "TownsquareGoalEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "ScalarField",
                "name": "accountId"
              },
              (v8/*: any*/),
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalUpdatesAsideViewAggQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "completedGoalsSearchString",
            "variableName": "completedGoalsSearchString"
          },
          (v4/*: any*/),
          {
            "kind": "Variable",
            "name": "newGoalsSearchString",
            "variableName": "newGoalsSearchString"
          },
          {
            "kind": "Variable",
            "name": "ownGoalsSearchString",
            "variableName": "ownGoalsSearchString"
          }
        ],
        "kind": "FragmentSpread",
        "name": "GoalUpdatesSideColumnAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalUpdatesAsideViewAggQuery",
    "selections": [
      {
        "alias": "ownGoals",
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "ownGoalsSearchString"
          },
          {
            "kind": "Literal",
            "name": "sort",
            "value": [
              "NAME_ASC"
            ]
          }
        ],
        "concreteType": "TownsquareGoalConnection",
        "kind": "LinkedField",
        "name": "goals_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareGoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TownsquareGoal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "concreteType": "TownsquareUserConnection",
                    "kind": "LinkedField",
                    "name": "watchers",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "count"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v10/*: any*/)
        ]
      },
      {
        "alias": "newGoals",
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "newGoalsSearchString"
          },
          (v11/*: any*/)
        ],
        "concreteType": "TownsquareGoalConnection",
        "kind": "LinkedField",
        "name": "goals_search",
        "plural": false,
        "selections": (v12/*: any*/)
      },
      {
        "alias": "completedGoals",
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "completedGoalsSearchString"
          },
          (v11/*: any*/)
        ],
        "concreteType": "TownsquareGoalConnection",
        "kind": "LinkedField",
        "name": "goals_search",
        "plural": false,
        "selections": (v12/*: any*/)
      }
    ]
  },
  "params": {
    "id": "9cfd27e96cde0fd15266ddb2222eed4ee194d3a64fe28737274c99b2e21fe6db",
    "metadata": {},
    "name": "GoalUpdatesAsideViewAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6f3d3ab78be05ac5fd15f7a01894391a";

export default node;
